import React, { ReactNode } from 'react';
import { ExtendedMonitoredTv, MonitoredMeasure, NoteEvent } from 'app/model/SOL49';
import { ManagedColumn } from 'app/common/table/ManagedTable';
import NoteTable, { NoteColumns } from 'app/components/panels/predict/notes/NoteTable';
import KeyUtils from 'app/common/util/KeyUtils';
import { NoteForm } from 'app/components/panels/predict/notes/NoteForm';
import { ServiceFactory } from 'app/service/ServiceFactory';
import { notification } from 'antd';
import {
    AbstractMonitoredEventPanel,
    AbstractMonitoredEventPanelProps,
} from 'app/components/panels/predict/AbstractMonitoredEventPanel';
import { NoteToolbar } from 'app/components/dashboard/global/events/MonitoredEventToolbar';
import { MonitoredEventUtils } from 'app/common/util/MonitoredEventUtils';
import Utils from 'app/common/util/Utils';

export interface NotePanelProps extends AbstractMonitoredEventPanelProps<NoteEvent> {
    tv?: string;
    defaultMeasures?: string[];
    defaultFmp?: string[];
    measures?: MonitoredMeasure[];
    tvs?: ExtendedMonitoredTv[];
    fmps?: Set<string>;
}

export class NotePanel extends AbstractMonitoredEventPanel<NoteEvent, NotePanelProps> {
    protected columns: ManagedColumn<NoteEvent>[] = NoteColumns;

    getDefaultEvent(): NoteEvent {
        return {
            tvs: this.props.tv && [this.props.tv],
            measures: this.props.defaultMeasures || [],
            fmps: this.props.defaultFmp?.filter(fmp => Utils.isExists(fmp)),
        };
    }

    getForm(event: NoteEvent): React.ReactNode {
        return (
            <NoteForm
                event={event}
                tvs={this.props.tvs}
                measures={this.props.measures}
                fmps={this.props.fmps}
                onCreate={this.onCreate}
                onUpdate={this.onUpdate}
                onDelete={this.onDelete}
            />
        );
    }

    getTable(events: NoteEvent[], selected: NoteEvent): React.ReactNode {
        return (
            <NoteTable
                highlight={this.highlight}
                data={events}
                columns={this.columns}
                keyProvider={KeyUtils.MONITORED_EVENT_KEY_PROVIDER}
                noDataMessage={'No notes'}
                selection={this.selection(selected)}
            />
        );
    }

    protected getToolbar(): ReactNode {
        return (
            <NoteToolbar
                onAddNote={() => this.setState({ selected: undefined })}
                showTags={true}
                settings={this.props.settings}
                onSettings={this.onSettingsChange}
                disabled={Utils.isNotExists(this.state.selected)}
            />
        );
    }

    protected refresh = () => {
        ServiceFactory.sol49Service()
            .getMonitoredEvents({ tv: this.props.tv })
            .then(reply => this.setState({ events: reply.data.filter(MonitoredEventUtils.isNoteEvent) }))
            .catch(err => notification.error({ message: 'Error fetching events', description: '' + err }))
            .finally(() => this.setState({ loading: false }));
    };
}
